<template>
  <div class="yun-side-bar-container">
    <sidebar-logo />
    <el-scrollbar wrap-class="yld-scrollbar-wrapper">
      <el-menu
        :collapse="true"
        :unique-opened="true"
      >
        <sidebar-item
          v-for="(item, index) in menu_list"
          :key="item.id"
          :item="item"
          :index="index + ''"
          :current-path="currentPath"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual'
import { mapGetters } from 'vuex'
import SidebarLogo from './Logo.vue'
import SidebarItem from './SidebarItem.vue'

export default {
  components: { SidebarItem, SidebarLogo },
  data() {
    return {
      currentPath: ''
    }
  },
  computed: {
    ...mapGetters([
      'menu_list',
      'sidebar'
    ]),
    variables() {
      return document.body.style.getPropertyValue('--geek-color-menuBar').trim()
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!isEqual(newVal, oldVal)) {
          this.currentPath = newVal.meta.parentPath
          // this.currentPath = newVal.path
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import './sidebar.scss';
  .yld-scrollbar-wrapper {
    margin-top: 20px;
    .is-first-active {
      & > .el-submenu__title,
      & > .el-menu-item {
        background: #f5f5f5 !important;
      }
    }
    .el-menu-item:hover{
      background: #f5f5f5 !important;
    }
    .el-submenu:hover{
      background: #f5f5f5 !important;
      & > .el-submenu__title {
        background: #f5f5f5 !important;
      }
    }
  }

</style>
